// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"93a4f583","196":"41039b9a","378":"ef30e1a0","496":"7fb4e4c4","726":"7efd1d8c","948":"1960f8bc"}[chunkId] + ".chunk.js";
};